import { track } from '../services/analytics/analytics'
import { openChat } from './set-crisp-session-info'

export const openSupportChat = (eventName?: string) => {
  if (eventName) {
    track(eventName, {})
  }
  openChat(true)
}
